// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_CriarOrcamentoPDFResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /orcamentos/criarOrcamentoPDF
 *
 * Returns the PDF document result from html2pdf service.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orcamentos_CriarOrcamentoPDFResponseDados {
documento_id: number
documento_url: string
mensagem: string
}

export type Orcamentos_CriarOrcamentoPDFResponse = ApiResponse<Orcamentos_CriarOrcamentoPDFResponseDados>;

registerResponseContract('Orcamentos_CriarOrcamentoPDFResponse', {
  documento_id:  { type: 'number',  required: false },
  documento_url: { type: 'string',  required: false },
  mensagem:      { type: 'string',  required: false },
})
